import React, { type ReactElement } from 'react';
import { Input as AntInput, type InputProps as AntInputProps } from 'antd';
import classNames from 'classnames';

export interface InputProps extends AntInputProps {
  label?: string;
  hintData?: string[];
  onConfirm?: () => void;
}

export default function Input({
  label,
  rootClassName,
  hintData = [],
  onChange,
  value,
  onConfirm,
  ...rest
}: InputProps): ReactElement {
  const handlePressEnter = (e: React.KeyboardEvent<HTMLInputElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      if (onConfirm) {
        onConfirm();
      }
    }
  };

  return (
    <>
      <label className="text-xs text-gray-400">{label}</label>
      <AntInput
        rootClassName={classNames('input !py-[10px]', rootClassName)}
        value={value}
        onChange={onChange}
        onKeyDown={handlePressEnter}
        {...rest}
      />
    </>
  );
}
